// @flow

export const UPDATE_SOCIAL = "UPDATE_SOCIAL";
export const UPDATE_CHAT = "UPDATE_CHAT";
export const UPDATE_VIDEO = "UPDATE_VIDEO";
export const UPDATE_PORTAL = "UPDATE_PORTAL";
